import { ObjectHandle, LineType, MaterialHandle } from '@inter-ikea-betrakta/viewer';
import { interactiveColor, nonInteractiveColor } from './HelpLinesSystem';
import { Vector } from '@inter-ikea-core/core';
const handlesColor = { r: 0 / 255, g: 58 / 255, b: 133 / 255 };
export class Corner {
    constructor(point, nextPoint, viewer, onDrag, onDragEnd, measurementLabelHidden, handleNotVisible, rotation, wallPosition, editMode) {
        this.wallCenterPosition = new Vector(0, 0, 0);
        this.wallCenterPosition = wallPosition ? wallPosition.times(0.001) : new Vector(0, 0, 0);
        this.rotation = rotation;
        this.handleNotVisible = handleNotVisible;
        this.measurementLabelHidden = measurementLabelHidden;
        this.handle = this.createHandle(viewer, point, onDrag, onDragEnd);
        this.lineId = this.createLine(viewer, point, nextPoint, editMode);
    }
    createViewerHandle(viewer) {
        const handle = new ObjectHandle(viewer.create_sphere(), viewer);
        handle.scale.x = this.handleNotVisible ? 0.001 : 0.1;
        handle.scale.y = this.handleNotVisible ? 0.001 : 0.1;
        handle.scale.z = this.handleNotVisible ? 0.001 : 0.01;
        handle.rotation = { x: 0, y: this.rotation ? this.rotation / (180 / Math.PI) : 0, z: 0 };
        return handle;
    }
    createViewerMaterialHandle(material, viewer) {
        return new MaterialHandle(material, viewer);
    }
    /**
     * Creates a draggable handle
     * @param viewer Viewer
     * @param point Current corner position
     * @param onDrag Executed when dragging the handle
     * @param onDragEnd Executed when releasing the handle
     * @returns
     */
    createHandle(viewer, point, onDrag, onDragEnd) {
        const handle = this.createViewerHandle(viewer);
        handle.position.x = point.x + this.wallCenterPosition.X;
        handle.position.y = point.y;
        handle.position.z = this.wallCenterPosition.Z; // Lines should be positioned at the same Z position as the wall
        if (this.handleNotVisible) {
            handle.visible = false;
        }
        // Create material before changing color
        handle.material = viewer.create_material('');
        const blue_material = this.createViewerMaterialHandle(handle.material, viewer);
        blue_material.roughness = 1.5;
        blue_material.metallic = 0.0;
        blue_material.base_color = handlesColor; // a rich blue color
        viewer.get_object_drag_observable(handle.id).add((objectId, event) => {
            onDrag(this, event.local_delta);
        });
        viewer.get_object_drag_end_observable(handle.id).add(() => {
            onDragEnd();
        });
        return handle;
    }
    /**
     * Creates a line between current point and the next.
     * @param viewer Viewer
     * @param point Current corner position
     * @param nextPoint Next corner position
     * @returns a line between the 2 points
     */
    createLine(viewer, point, nextPoint, editMode) {
        return viewer.create_ui_line(LineType.SOLID, point, nextPoint, editMode ? interactiveColor : nonInteractiveColor, 0.01);
    }
    setLineColor(viewer, color) {
        viewer.update_ui_line(this.lineId, this.handle.position, undefined, color);
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} z
     */
    moveTo(x, y, z) {
        this.handle.position.x = x;
        this.handle.position.y = y;
        this.handle.position.z = z;
    }
    snapPosition() {
        this.handle.position.x = Math.round(this.handle.position.x * 100) / 100;
        this.handle.position.y = Math.round(this.handle.position.y * 100) / 100;
        this.handle.position.z =
            this.handle.position.z > 0.002
                ? Math.round(this.handle.position.z * 100) / 100
                : this.handle.position.z;
    }
    getPosition() {
        return this.handle.position;
    }
}
//# sourceMappingURL=Corner.js.map